import { documentTypeApi } from "../api";

const DocumentTypeService = {
  fetchDropdown: async () => {
    const response = await documentTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default DocumentTypeService;
